/**
 * Simplified AWS Amplify Configuration
 * Uses amplifyconfiguration.json for clean, environment-free setup
 */

import { Amplify } from 'aws-amplify';
import amplifyConfig from '../amplifyconfiguration.json';

/**
 * Initialize AWS Amplify with the configuration from amplifyconfiguration.json
 */
export const initializeAmplify = () => {
  try {
    // Configure Amplify with the imported configuration
    Amplify.configure(amplifyConfig);
    
    const apiConfig = amplifyConfig.aws_cloud_logic_custom?.[0];
    
    console.log('[Amplify] Configuration initialized successfully');
    if (apiConfig) {
      console.log('[Amplify] API Name:', apiConfig.name);
      console.log('[Amplify] API Endpoint:', apiConfig.endpoint);
      console.log('[Amplify] Region:', apiConfig.region);
    }
    
    return true;
  } catch (error) {
    console.error('[Amplify] Failed to initialize configuration:', error);
    return false;
  }
};

/**
 * Check if Amplify is properly configured
 */
export const isAmplifyConfigured = () => {
  try {
    const config = Amplify.configure();
    return !!(config?.aws_cloud_logic_custom?.length > 0);
  } catch (error) {
    console.error('[Amplify] Error checking configuration:', error);
    return false;
  }
};

/**
 * Get current Amplify configuration
 */
export const getAmplifyConfig = () => {
  try {
    return Amplify.configure();
  } catch (error) {
    console.error('[Amplify] Error getting configuration:', error);
    return null;
  }
};

/**
 * Get API configuration details
 */
export const getApiDetails = () => {
  try {
    const apiConfig = amplifyConfig.aws_cloud_logic_custom?.[0];
    if (!apiConfig) {
      return { error: 'No API configuration found' };
    }
    
    return {
      name: apiConfig.name,
      endpoint: apiConfig.endpoint,
      region: apiConfig.region,
      projectRegion: amplifyConfig.aws_project_region
    };
  } catch (error) {
    console.error('[Amplify] Error getting API details:', error);
    return { error: error.message };
  }
};

export default {
  initializeAmplify,
  isAmplifyConfigured,
  getAmplifyConfig,
  getApiDetails
};